import { useState, useCallback } from 'react';
import api, { setToken, removeToken } from '../services/api';

const USUARIO_KEY = 'auth_usuario';

const carregarUsuarioSalvo = () => {
  try {
    const raw = sessionStorage.getItem(USUARIO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export default function useAuth() {
  const [usuario, setUsuario] = useState(carregarUsuarioSalvo);
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, senha) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, senha });
      const { token, usuario: usuarioRetornado } = data.data;
      setToken(token);
      sessionStorage.setItem(USUARIO_KEY, JSON.stringify(usuarioRetornado));
      setUsuario(usuarioRetornado);
      return { sucesso: true, usuario: usuarioRetornado };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    setLoading(true);
    try {
      await api.post('/auth/logout');
    } catch {
      // ignora erros de rede no logout
    } finally {
      removeToken();
      sessionStorage.removeItem(USUARIO_KEY);
      setUsuario(null);
      setLoading(false);
    }
  }, []);

  return {
    usuario,
    loading,
    autenticado: !!usuario,
    login,
    logout,
  };
}
